export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message)
    this.name = 'ApiError'
  }
}

export class PlanLimitError extends ApiError {
  constructor(
    message: string,
    public readonly limit: number,
    public readonly current: number,
  ) {
    super(402, message)
    this.name = 'PlanLimitError'
  }
}
